<template src="./html/Edit.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import Products from '../../productStorages/views/Products.vue'
	import productStorages from '../../productStorages/layout/productStorages.vue'
	import Navbar from './Navbar'
	export default {
		props: ['user', 'isAuth'],
		components: {
			'products': Products,
			'product-storages': productStorages,
			'navbar': Navbar,
		},
		data () {
			return {
				modal: {
					selector: 'product-create',
				},
				item: null,
				loading: false,
				taxes: null,
				currencies: null,
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				this.getData()
				this.getTaxes()
				this.getCurrencies()
			},
			reload() {
				this.getData()
			},
			getTaxes() {
				this.$http.get('admin/management/taxes')
					.then(response => {
						this.taxes = response.body
					})
			},
			getCurrencies() {
				this.$http.get('admin/cms/currencies')
					.then(response => {
						this.currencies = response.body
					})
			},
			getData () {
				var id = this.$route.params.id
				if(id) {
					this.$http.get('admin/management/orders/' + id + '/edit')
						.then(response => {
							this.item = response.body
							$('#table-products tbody tr').removeClass('disabled')
							$('#table-products tbody tr td input').attr('disabled', false)
						}).catch(response => {
							console.log(response)
							$('#table-products tbody tr').removeClass('disabled')
							$('#table-products tbody tr td input').attr('disabled', false)
							if(response.status == 423) {
								swal({
									title: response.body.title,
									text: response.body.text,
									type: response.body.type,
								})
							} else {
								if(response.status == 409) {
									swal({
										title: response.body.title,
										text: response.body.text,
										type: response.body.type,
									})
								} else {
									swal({
										title: response.statusText,
										text: response.body,
										type: 'warning',
									})
								}
							}
						})
				}
			},
			changeTax(el) {
				var select = el.currentTarget
				select.setAttribute('disabled', true)
				this.loading = true
				if(this.item.tax_id) {
					var api = 'admin/management/orders/' + this.item.id + '/change/tax/' + this.item.tax_id
				} else {
					var api ='admin/management/orders/' + this.item.id + '/change/tax'
				}
				this.$http.get(api)
					.then(response => {
						select.removeAttribute('disabled')
						this.loading = false
						this.getData()
					})
			},
			editProduct(product) {
				this.$refs.productStorages.editProduct(product)
			},
			changeCurrency(el) {
				var select = el.currentTarget
				select.setAttribute('disabled', true)
				this.loading = true
				if(this.item.currency_id) {
					this.$http.get('admin/management/orders/' + this.item.id + '/change/currency/' + this.item.currency_id)
						.then(response => {
							this.loading = false
							select.removeAttribute('disabled')
							this.getData()
						}).catch(response => {
							this.loading = false
							select.removeAttribute('disabled')
							if(response.status == 409) {
								swal({
									title: response.statusText,
									text: response.body,
									type: 'warning',
								})
							}
							this.getData()
						})
				}
			},
			update() {
				var that = this
				var loading = Ladda.create(this.$refs.btnUpdate)
				loading.start()
				this.$http.put('admin/management/orders/' + this.item.id, this.item)
				.then(response => {
					loading.stop()
					$('#modal-edit-order').modal('hide')
					this.reload()
					swal({
						title: response.body.title,
						text: response.body.text,
						type: response.body.type
					})
				}).catch(function(response) {
					console.log(response)
					loading.stop()
					$('#modal-edit-order').modal('hide')
					this.reload()
				})
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/management/orders/views/Edit.vue